import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {API_BASE_URI} from '../http/api';
import {ScheduledAction} from '@core/data/types/scheduled-action';

export interface ScheduledActionCreateManyRequest {
    actions: Partial<ScheduledAction>[];
}

@Injectable()
export class ScheduledActionService {

    constructor(
        private _http: HttpClient,
        @Inject(API_BASE_URI) private _baseUri: string,
    ) {
    }

    createMany(data: ScheduledActionCreateManyRequest): Observable<ScheduledAction[]> {
        return this._http.post<ScheduledAction[]>(`${this._baseUri}/scheduled-actions/many`, data);
    }
}
